<template>
  <div style="width:800px">
    <el-table :data="tableData" border row-key="id" stripe align="left">
      <el-table-column type="index" label="序号" width="50"></el-table-column>
      <el-table-column prop="imageUrl" label="出版社图标">
        <template slot-scope="scope">
          <el-image style="width: 50px; height: 50px" :src="scope.row.imageUrl"></el-image>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item, index) in col"
        :key="`col_${index}`"
        :prop="item.prop"
        :label="item.label"
      ></el-table-column>
      <el-table-column prop="orgOrder" label="拖拽排序">
        <template>
          <el-button type="primary" icon="el-icon-s-operation"></el-button>
        </template>
      </el-table-column>
      <el-table-column fixed="right" label="操作" width="200">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">选择出版社</el-button>
          <el-button type="text" @click="handleRemove(scope.row)" size="small">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      v-bind="dialogOption"
      :view.sync="dialogOption.view"
      :visible.sync="dialogOption.show"
      :destroy-on-close="true"
      :close-on-click-modal="false"
    >
      <component :is="dialogOption.view" @close="closeDialog"></component>
    </el-dialog>
  </div>
</template>
<script>
import Sortable from "sortablejs";
import publisherSelect from "./publisherSelect";
import {
  queryActionList,
  deleteActionRow,
  savePublisher,
  updatPublisher,
  sysUpdate
} from "@/api/sysinfo";
import { Message } from "element-ui";
export default {
  components: { publisherSelect },
  data() {
    return {
      col: [
        {
          label: "出版社名称",
          prop: "lable"
        }
      ],
      tableData: [],
      dialogOption: {
        title: "选择出版社",
        width: "1200px",
        view: "",
        show: false
      },
      updateRow: {},
      position: 3
    };
  },
  mounted() {
    this.rowDrop();
    // 需要请求后台数据，对页面进行初始化
    this.getData();
  },
  methods: {
    //行拖拽
    rowDrop() {
      const tbody = document.querySelector(".el-table__body-wrapper tbody");
      const _this = this;
      Sortable.create(tbody, {
        onEnd({ newIndex, oldIndex }) {
          const currRow = _this.tableData.splice(oldIndex, 1)[0];
          _this.tableData.splice(newIndex, 0, currRow);
          let params = [];
          _this.tableData.forEach((item, index) => {
            let data = {
              columnIndex: index,
              linkid: item.linkid
            };
            params.push(data);
          });
          sysUpdate(params, _this.position).then(data => {
            _this.tableData = [];
            _this.getData();
          });
        }
      });
    },
    // 选择出版社
    handleClick(row) {
      this.showDialog("选择出版社", "publisherSelect");
    },
    // 删除
    handleRemove(row) {
      if (this.tableData.length === 1) {
        this.$message({
          message: "最后一行数据不能进行删除操作",
          type: "error",
          duration: 5 * 1000
        });
        return;
      }
      this.$confirm("是否确认删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let params = {
            linkId: row.linkid
          };
          deleteActionRow(params).then(data => {
            Message({
              message: "删除成功",
              type: "success",
              duration: 5 * 1000
            });
            this.getData();
          });
        })
        .catch(() => {});
    },
    // 打开对话框
    showDialog(title, view, width = "1200px") {
      this.dialogOption.view = view;
      this.dialogOption.title = title;
      this.dialogOption.show = true;
    },
    // 关闭出版社窗体保存
    closeDialog(val) {
      // 如果有值传进来，则做更新操作
      this.dialogOption.show = false;
      this.dialogOption.view = "";
      this.dialogOption.title = "";
      if (val) {
        this.updateRow = val;
        // console.log(val);
        let params = {
          describes: "主推出版社",
          lable: val.orgName,
          position: this.position,
          columnIndex: this.tableData.length + 1,
          imageUrl: val.orgLogo,
          linkUrl:
            "/exhibitionGood/action/pageOrder?currentPage=1&pageSize=24&publisherId=" +
            val.gid,
          tips: val.orgName,
          rowIndex: 1
        };
        savePublisher(params).then(data => {
          if (data.data) {
            Message({
              message: "插入成功",
              type: "success",
              duration: 5 * 1000
            });
            this.getData();
          }
        });
      }
    },
    // 获取数据
    getData() {
      let params = {
        position: this.position
      };
      queryActionList(params).then(data => {
        this.tableData = data.data;
      });
    }
  }
};
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/sysmanager/ClassifyInfo/PublisherSuggest/index.vue